import React from 'react'
import { PickingStatesSquareProps } from './interfaces'
import { useStyles } from './styles'
import { PickingItem } from './PickingItem'
import { RoutesList } from './RoutesList'
import { usePickingReport } from '../../Context/usePickingReport'

export const PickingStatesSquare = ({
  ...styles
}: PickingStatesSquareProps) => {
  const classes = useStyles()
  const { state } = usePickingReport()
  return (
    <div className={classes.container}>
      <div
        className={classes.containerlist}
        style={styles ? { ...styles } : {}}
      >
        {state.cardsItems.map(
          (item) =>
            item.height !== '0%' && <PickingItem {...item} key={item.title} />
        )}
      </div>

      {state.isShowRoutes && (
        <RoutesList
          picking={state.selectPickingState}
          routes={state.pickingDetailItems.map(
            (x) => `Ruta ${x.pickingRouteId}`
          )}
        />
      )}
    </div>
  )
}
